<template>
  <main id="main" :class="{'collapsed-menu' : isCollapsedMenu}" class="main">
    <Sidebar/>
    <div class="cover-overlay" v-if="isCollapsedMenu" @click="toggleMenu"></div>
    <div class="main-content">
      <div class="main-head">
        <div class="collapse-sidebar" @click="toggleMenu"><i :class="isCollapsedMenu ? 'bx bx-right-indent' : 'bx bx-left-indent'"></i></div>
        <div class="token-info">
          <template v-if="!isConnected">
            <a class="btn btn-wallet-connect" @click.prevent="showWalletProviders"
            ><i class="bx bx-wallet-alt"></i><span>{{ $t('BTN_WALLET_CONNECT') }}</span></a>
          </template>
          <template v-else>
            <div class="address-info">
              <img src="/assets/images/icons/bsc.svg" alt="Network">
              <span>
               {{ beautySelectedAddress }}
              </span>
              <i class="el-icon-copy-document"></i>
            </div>
          </template>
          <div class="menu-user" v-if="user.email">
            <i class="bx bxs-user"></i><span>{{ user.email }}</span>
            <div class="menu-submenu">
              <ul>
                <li class="email-info"><i class="bx bx-envelope"></i><span>{{ user.email }}</span></li>
                <li><router-link :to="{name: 'profile'}"><i class="bx bxs-user"></i>Profile</router-link></li>
                <li v-if="isConnected"><span @click="disconnect"><i class="bx bxs-wallet"></i>Disconnect Wallet</span></li>
                <li><a @click.prevent="logout()"><i class="bx bx-log-out-circle"></i>Logout</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="main-body">
        <router-view/>
      </div>
    </div>
    <BuyPackage/>
    <Deposit/>
    <DepositSuccess/>
    <WalletProvider/>
    <ChangePassword/>
    <DepositAddress/>
    <WithdrawForm/>
    <FAForm/>
  </main>
</template>

<script>
import Sidebar from './components/Sidebar'
import BuyPackage from '@/views/modal/BuyPackage.vue'
import Deposit from '@/views/modal/Deposit'
import DepositSuccess from '@/views/modal/DepositSuccess'
import DepositAddress from '@/views/modal/DepositAddress'
import WithdrawForm from '@/views/modal/WithdrawForm'
import WalletProvider from '@/views/modal/WalletProvider'
import ChangePassword from '@/views/modal/ChangePassword'
import FAForm from '@/views/modal/2FA'

export default {
  components: {
    Sidebar,
    BuyPackage,
    Deposit,
    WalletProvider,
    DepositSuccess,
    ChangePassword,
    DepositAddress,
    WithdrawForm,
    FAForm
  },
  data () {
    return {
      currentLanguage: null,
      isCollapsedMenu: false,
      openLanguage: false
    }
  },
  computed: {
    beautySelectedAddress () {
      const firstStr = this.selectedAddress.substring(0, 6)
      const lastStr = this.selectedAddress.substring(this.selectedAddress.length - 5, this.selectedAddress.length)
      return firstStr + '...' + lastStr
    },
    isConnectedWallet () {
      return this.bridgeConnector.bridge || this.web3.currentProvider
    },
    ethereum () {
      return this.$store.getters.ethereum
    },
    web3 () {
      return this.$store.getters.web3
    },
    currentLang () {
      return this.$store.getters.currentLang
    },
    languages () {
      return this.$store.getters.languages
    },
    configs () {
      return this.$store.getters.configs
    },
    user () {
      return this.$store.getters.user
    },
    activeRound () {
      return this.$store.getters.activeRound
    },
    bridgeConnector () {
      return this.$store.getters.bridgeConnector
    },
    selectedAddress () {
      return this.$store.getters.selectedAddress
    },
    isConnected () {
      return this.$store.getters.isConnected
    }
  },
  watch: {
    currentLang (val) {
      val && (this.currentLanguage = val)
    },
    $route () {
      const ww = window.innerWidth
      if (ww < 1200 && this.isCollapsedMenu) {
        this.isCollapsedMenu = false
      }
    }
  },
  created () {
    if (this.currentLang) this.currentLanguage = this.currentLang
    this.$store.dispatch('getUserConfig', 'ALEO')
    this.$store.dispatch('getUser')
    this.$store.dispatch('getUserOverview')
    this.$store.dispatch('getBalances')
    this.$store.dispatch('getTotalPPS')
  },
  async mounted () {
  },
  methods: {
    logout () {
      this.$confirm('Logout', this.$t('TEXT_CONFIRM'), {
        confirmButtonText: this.$t('BTN_OK'),
        cancelButtonText: this.$t('BTN_CANCEL'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logout')
      }).catch(() => {
      })
    },
    showWalletProviders () {
      this.$store.dispatch('toggleWalletProviderForm')
    },
    disconnect () {
      this.$store.dispatch('disconnect')
    },
    toggleMenu () {
      this.isCollapsedMenu = !this.isCollapsedMenu
    }
  }
}
</script>
